exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n}\n\n.api-toolbar {\n  -ms-flex-align: center;\n      align-items: center;\n  background: #f6f9fc;\n  border: 1px solid #dbe4ef;\n  border-bottom: 0;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 12px;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 10px;\n}\n\n.api-toolbar span {\n  color: #587189;\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.api-toolbar strong {\n  color: #13283c;\n  display: block;\n  font-size: 20px;\n  margin-top: 2px;\n}\n\n.api-toolbar button {\n  background: #ffffff;\n  border: 1px solid #cdd9e5;\n  border-radius: 4px;\n  color: #1d3d5c;\n  cursor: pointer;\n  font-weight: 700;\n  padding: 8px 12px;\n}\n\n.error-message {\n  background: #fff5f5;\n  border: 1px solid #ffd6d6;\n  color: #982828;\n  margin: 0;\n  padding: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /storage/data/github/tests/angular-data-table-component/angular-4/src/app/examples/http-client-data/http-client-data.component.css
// module id = ../../../../../src/app/examples/http-client-data/http-client-data.component.css
// module chunks = main